import { render, staticRenderFns } from "./follow_key_items.vue?vue&type=template&id=15134ab2"
import script from "./follow_key_items.vue?vue&type=script&lang=js"
export * from "./follow_key_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports